/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToRem } from '@insticator/insticator-ui'; // iui-utils

/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION : STYLES --------------- ++++++++++ */
export default theme => ({
  sectiongroup: {
    '&:not(:first-child)': {
      marginTop: pxToRem(48),
    },
    '&.secondary:not(:first-child)': {
      marginTop: pxToRem(16),
    },
    '&.secondary > .sectiongroupdescription > h2': {
      fontWeight: 500,
      fontSize: pxToRem(14),
      marginBottom: pxToRem(8)
    },
    '& > .field': {
      marginTop: pxToRem(16)
    },
    '&.secondary > .field': {
      marginTop: pxToRem(8)
    },
    '&.row': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    
    '& .toggle': {
      marginLeft: pxToRem(16),
      marginTop: pxToRem(2),
      maxWidth: pxToRem(40),
      height: pxToRem(22),
      '& .ball': {
        height: pxToRem(18),
        width: pxToRem(18)
      }
    }
  }
});
